<template>
  <v-dialog v-model="modal"  max-width="600" max-height="98%" persistent>
    <div class="J-modal-login">
      <div class="J-modal-close">
          <button type="button" class="close" @click="close()">
              <span aria-hidden="true">&times;</span>
          </button>
      </div>
      <login-component v-if="tab[0].visible" @close="close"  @activeRegister="isActiveTabs"/>
      <register-login-component v-if="tab[1].visible" @activeLogin="isActiveTabs"/>
      <help-component v-if="tab[2].visible" @close="close"/>
      <search-danger-component v-if="tab[3].visible" @close="close"/>
      <galery-component v-if="tab[4].visible" @close="close"/>
      <referrals-component v-if="tab[5].visible" @close="close"/>

      <component-favoriteslaundries v-if="tab[6].visible"/>
      
    </div>
  </v-dialog>
</template>

<script>
import { EventBus } from '../../../helpers/eventbus/event-bus'
import registrousuarios from '../modulos/Usuarios/registrousuarios'
import modalhelp from '@/components/modals/AlertHelp.modal'
import modalDanger from '@/components/modals/SearchDanger.modal'
import modalGalery from '@/components/modals/Galery.modal'
import modalReferrals from '@/components/modals/Referrals.modal'
import favoriteslaundries from '@/components/Templates/Views/favoriteslaundries'
import {RoutesStorage} from '@/helpers/storage'

import login from '../modulos/Usuarios/login'
// Modelos
import {
    mapGetters,
    mapActions
} from 'vuex'
  export default {
      data () {
        return {
          routesStorage:new RoutesStorage(),

          tab:[
              {name:'',checked:false,visible:true},
              {name:'',checked:false,visible:false},
              {name:'',checked:false,visible:false},
              {name:'',checked:false,visible:false},
              {name:'',checked:false,visible:false},
              {name:'referrals',checked:false,visible:false},
              {name:'favorites',checked:false,visible:false},
          ],
          dialog: false,
          modal:false,
          dialog2: false,
          dialog3:false,
        }
      },
      computed: mapGetters({
        indetityU: 'getIdentity',
        tokenU: 'getToken'
      }),
      mounted(){
        EventBus.$on('goLogin', () =>{
          this.goLogin()
        })
        EventBus.$on('goModalHelp', () =>{
          this.goModalHelp()
        })
        EventBus.$on('goModalDanger', () =>{
          this.goModalDanger()
        })
         EventBus.$on('goRegister', () =>{
          this.goRegister()
        })
         EventBus.$on('goModalGalery', () =>{
          this.goActive(4)
        })
        EventBus.$on('goModalReferrals', () =>{
          this.goActive(5)
        })
        EventBus.$on('openmodalfavoritescompany', () =>{
          this.goActive(6)
        })
      },
      methods: {
        goActive:function(i){
          this.modal = true
          this.isActiveTabs(i)
        },
        close:function(){
          this.modal = false
        },
        isActiveTabs:function(index){
            this.tab.forEach(element => {
                element.visible=false;
            });
            this.tab[index].visible=true;
        }, 
        goModalHelp(){
          if(!this.modal){
            this.modal = false
            this.isActiveTabs(2)
          }
        },
        goLogin(){
          if(!this.modal){
            this.modal = true
            this.routesStorage.set({login: window.location.href})
            this.isActiveTabs(0)
          }
        },
        goRegister(){
          this.modal = true
          this.isActiveTabs(1)
        },
        goModalDanger(){
          this.modal = true
          this.isActiveTabs(3)
        }
      },
      components:{
        'register-login-component':registrousuarios,
        'login-component':login,
        'help-component':modalhelp,
        'search-danger-component':modalDanger,
        'galery-component':modalGalery,
        'referrals-component':modalReferrals,
        'component-favoriteslaundries':favoriteslaundries,
      }

      
  }
</script>